import { memo } from 'react'
import { isEqual } from 'lodash'
import NewMemberDeclarationContainer from 'app/containers/NewMemberDeclaration'
import { PageTitle } from 'app/components/common/PageTitle'
import { useTranslation } from 'react-i18next'
import R from 'app/assets/R'

const NewMemberDeclarationCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.new_member_declaration)}</PageTitle>
      <NewMemberDeclarationContainer />
    </>
  )
}
export const NewMemberDeclarationPage = memo(NewMemberDeclarationCpn, isEqual)
